



import { Vue, Component, Prop } from 'vue-property-decorator';
import HeaderLabel from '../../../components/atoms/HeaderLabel.vue';
@Component({ components: {} })
export default class LessonLabel extends Vue {}
